import { Dayjs } from 'dayjs'
import easternTimezonedDayjs from '../helpers/dayjsEastern'
import { Address, JsonAddress } from './address'
import { JsonModel, Model } from './model'

/**
 * Lightweight supplier row for the invoice batch generation table.
 *
 * Mirrors the backend {@link SupplierInvoiceBatchTableResource}, which only
 * exposes the fields that table renders (name, phone, physical address, last invoice).
 */
export class SupplierInvoiceBatchRow extends Model {
    name: string
    primaryPhone: string | null
    physicalAddress: Address | null
    lastInvoiceId: number | null
    lastInvoiceDate: Dayjs | null

    constructor(json: JsonSupplierInvoiceBatchRow) {
        super(json)

        this.name = json.name
        this.primaryPhone = json.primaryPhone ?? null
        this.physicalAddress = json.physicalAddress ? new Address(json.physicalAddress) : null
        this.lastInvoiceId = json.lastInvoiceId ?? null
        this.lastInvoiceDate = json.lastInvoiceDate
            ? easternTimezonedDayjs(json.lastInvoiceDate)
            : null
    }
}

export interface JsonSupplierInvoiceBatchRow extends JsonModel {
    name: string
    primaryPhone: string | null
    physicalAddress: JsonAddress | null
    lastInvoiceId?: number | null
    lastInvoiceDate?: string | null
}
